<div *ngIf="columnDefinitions.length > 0">
    <mat-card>
      <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel expanded="true" class="mt-3">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title">
                {{'enterprise_contract.ttl_search' | translate}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
              <div class="row">
                <!-- Số giấy tờ người lao động -->
                <div class="col-lg-6 col-md-6">
                  <mat-form-field class="w-100">
                    <input type="text"
                      (focusout)="focusOutCertificateNo()"
                      #focusInput matInput [placeholder]="'search_form.certificate_no_moha' | translate" name="certificateNo"
                      [(ngModel)]="documents.certificateNo" maxlength="255" autocomplete="off">
                    <button mat-button *ngIf="documents.certificateNo" type="button" matSuffix mat-icon-button
                      aria-label="Clear" (click)="documents.certificateNo=''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <!-- Email/Điện thoại/Tên người lao động -->
                <div class="col-lg-6 col-md-6">
                  <mat-form-field class="w-100">
                    <input type="text"
                      (focusout)="focusoutEmailOrPhone()"
                      matInput [placeholder]="'search_form.email_phone_name_employment' | translate" name="emailOrPhoneOrName"
                      [(ngModel)]="documents.emailOrPhoneOrName" maxlength="255" autocomplete="off">
                    <button mat-button *ngIf="documents.emailOrPhoneOrName" type="button" matSuffix mat-icon-button
                      aria-label="Clear" (click)="documents.emailOrPhoneOrName=''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <!-- button tìm kiếm -->
                <div class="col-lg-12 col-md-6 d-flex justify-content-center">
                  <div class="row mt-3">
                    <div class="col-lg-12 d-flex align-items-center justify-content-center">
                      <button mat-stroked-button color="primary" appTrackEvent="w.btn.hdtoilap.tim_kiem"
                        [disabled]="!myForm.valid">
                        <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                        {{'enterprise_contract.buttons.search' | translate}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </mat-expansion-panel>
        </mat-accordion>

        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel expanded="true" class="mt-3">
            <mat-panel-title class="mat-panel-title mb-2 pb-3 mt-3 d-flex align-items-center list-title-mine ">
              <div class="row">
                <div class="col-12"><span class="">{{'enterprise_contract.list_contract_personal' | translate}}
                    ({{paginate.totalRow}})
                </span></div>
              </div>
              <!-- <div class="buttonMD">
                <button class="btn1-mine" style="position: absolute; right: 24px" mat-stroked-button color="primary"
                  type="button" (click)="onAddDocument()" appTrackEvent="w.btn.hdtoilap.them_moi"
                >
                  <mat-icon class="mr-0">add_circle</mat-icon>
                  {{'button.add' | translate}}
                </button>
              </div> -->
            </mat-panel-title>
            <div class="mat-table-container table-container example-container" style=" display: block; max-height: 590px">
              <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                class="mat-table-col-extra-sm mat-table table" [ngStyle]="{'min-width': tableWidth + 'px'}">
                <!-- STT -->
                <ng-container matColumnDef="STT">
                  <mat-header-cell *matHeaderCellDef
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{'enterprise_contract.table_headers.No' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                    (click)="$event.stopPropagation()">
                    {{element.STT}}
                  </mat-cell>
                </ng-container>

                <!-- Tên -->
                <ng-container matColumnDef="fullName">
                  <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    {{'form.full_name' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" matTooltip="{{ element.fullName }}"
                    class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 30%;">
                    <span class="fix-width">{{ element.fullName }}</span>
                  </mat-cell>
                </ng-container>


                <!-- Số giấy tờ -->
                <ng-container matColumnDef="certificateNo">
                  <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"
                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    {{'contract_share_partner.certificate_no' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center" style="width: 20%;">
                    <span (click)="$event.stopPropagation()" matTooltip="{{element.certificateNo}}" class="fix-width"
                      style="margin-left: -5px;">
                      {{element.certificateNo}}
                    </span>
                  </mat-cell>
                </ng-container>



                <!-- Giới tính -->
                <ng-container matColumnDef="sex">
                  <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    {{'form.sex' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" [matTooltip]="getSex(element.sex)"
                  class="mat-cell-non-boder-right-bottom number-cell-center" (click)="$event.stopPropagation()" style="max-width: 15%;">
                    <span class="fix-width">{{ getSex(element.sex) }}</span>
                  </mat-cell>
                </ng-container>

                <!-- email -->
                <ng-container matColumnDef="email">
                  <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    <span>
                      {{'enterprise_branch_management.table_headers.email' | translate}}
                    </span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                    matTooltip="{{element.email}}" class="mat-cell-non-boder-right-bottom"
                    style="max-width: 15%;">
                    <span class="fix-width">{{ element.email }}</span>
                  </mat-cell>
                </ng-container>

                <!-- sdt -->
                <ng-container matColumnDef="phone">
                  <mat-header-cell *matHeaderCellDef style="min-width: 7%;" mat-sort-header
                    class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                    <span>
                        {{'enterprise_branch_management.table_headers.phone' | translate}}
                    </span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" matTooltip="{{ element.phone }}"
                    (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom number-cell-center" style="min-width: 7%;">
                    <span class="fix-width">{{ element.phone }}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="action" *ngIf="!commonService.getIsLockedEnterprise()">
                  <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 160px">
                    {{'headertable.action' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" style="min-width: 160px"
                    class="number-cell-center">

                    <!-- Xem chi tiết -->
                    <button mat-icon-button (click)="viewDetail(element)"
                      appTrackEvent="w.btn.hdtoilap.xem_chi_tiet">
                      <mat-icon matTooltip="{{'record_management_moha.view_dossier_info' | translate}}">
                        visibility
                      </mat-icon>
                    </button>

                    <!-- Tải xuống -->
                    <button mat-icon-button type="button" (click)="downloadFileEmploye(element)"
                      appTrackEvent="w.btn.hdtoilap.tai_file">
                      <mat-icon matTooltip="{{'record_management_moha.download_dossier' | translate}}">save_alt
                      </mat-icon>
                    </button>

                    <!-- Chuyển tiếp HĐ -->
                    <!-- <button mat-icon-button *ngIf="false" (click)="forwardContract(element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.chuyentiephd"
                      [disabled]="element.status !== enumContractStatus.FINISHED">
                      <i *ngIf="element.status == enumContractStatus.FINISHED"
                        class="fa fa-paper-plane fa-fw vt-cursor-pointer" aria-hidden="true"
                        style="color: #07736C;font-size: 1rem;"
                        matTooltip="{{'enterprise_customer_management.buttons.forward_contract' | translate}}">
                      </i>
                      <i *ngIf="element.status !== enumContractStatus.FINISHED"
                        class="fa fa-paper-plane fa-fw vt-cursor-pointer disable" style="font-size: 1rem;"
                        aria-hidden="true"></i>
                    </button> -->
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
                  [cdkDetailRow]="row" (toggleChange)="onToggleChange($event,row)">
                </mat-row>
              </mat-table>
            </div>

            <!-- Pagination -->
            <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
            </app-pagination>
          </mat-expansion-panel>
        </mat-accordion>


      </mat-card-content>
    </mat-card>
  </div>
